import { createContext } from "react";

const TodayHabitsContext = createContext();

export default TodayHabitsContext;
